import CustomerStoryVertical from "@components/BasicComponents/Cards/CustomerStory/CustomerStoryVertical"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import {CustomerStoryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CustomersCardsSection.module.scss"

type Props = {
	data: CustomerStoryModuleType[]
}

const CustomersCardsSection = (props: Props) => {
	const storiesArray = [
		"bureaucracy-simplified-with-video",
		"ponsse-ceo-cant-imagine-working-without-videos",
		"utilising-video-communication-to-create-a-sense-of-unity-for-scattered-workforce",
	]

	const matchedStories = props.data.filter((story) =>
		storiesArray.includes(story.slug),
	)

	let finalStories = [...matchedStories]

	if (finalStories.length < 3) {
		const remainingStories = props.data.filter(
			(story) => !finalStories.includes(story),
		)

		const shuffled = remainingStories.sort(() => 0.5 - Math.random())

		finalStories = finalStories.concat(
			shuffled.slice(0, 3 - finalStories.length),
		)
	}

	return (
		<ContainerWrapper>
			<div className={styles.cardContainer}>
				{finalStories.map((element, index) => (
					<CustomerStoryVertical
						key={index}
						className={styles.cardBox}
						data={element}
						onWhiteBackground
					/>
				))}
			</div>
		</ContainerWrapper>
	)
}

export default CustomersCardsSection
